module.exports = __webpack_public_path__ + "static/media/uk_flag.a6a5f1a2.svg";